import React from 'react'
import { FirmCard } from '../../../components/Component'
import McPageHelpers from '../McPageHelpers'
import useFirmDetails from '../../../hooks/useFirmDetails'

const ImporterNameCell = ({ row, qtyKey = 'hsTotalQuantity' }) => {
  const id = row.urlCode
  const firm = useFirmDetails(id)

  const displayName = firm.name || row.importerName || ' '

  return (
    <>
      <div data-tag="allowRowEvents" dir="ltr">{displayName}</div>
      <div
        className="position-fixed"
        id={`firmcard${id}`}
        style={{
          zIndex: '999',
          visibility: 'hidden',
          opacity: 0,
          transition: 'visibility 0s, opacity 0.1s linear 1s'
        }}
      >
        <FirmCard
          id={`spFirm_${id}`}
          firmName={displayName}
          helpText={firm.web || row.web}
          hsTotalValue={row.hsTotalValue}
          growth={row.growth}
          hsTotalQuantity={row[qtyKey]}
          numberOfShipments={row.numberOfShipments}
          tableName={McPageHelpers.SECTION_IDS.IMPORTER_COMPANIES}
          growthValue={row.growthValue}
          yearChartData={row.yearChartData}
        />
      </div>
    </>
  )
}

export default ImporterNameCell
